module.exports = "<i class=\"gmw-crypto-badge gmw-crypto-badge--{{crypto.toLowerCase()}}\"></i> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/cryptocurrencies/directives/crypto-badge/crypto-badge.html
// module id = 508
// module chunks = 0